import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { Console } from './pages/counter/Console';
import { Dashboard } from './pages/manager/Dashboard';
import { VisitingOfficers } from './pages/scheduler/VisitingOfficers';
import { Catalogue } from './pages/admin/Catalogue';
import { TvPicker } from './pages/tv/Picker';
import { TvBoard } from './pages/tv/Board';
import { Shell } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  // One workspace, not one-per-role — but land each persona somewhere useful
  // for their primary duty rather than always defaulting to the counter.
  const landing = persona.roles.includes('COUNTER_OFFICER')
    ? '/counter'
    : persona.roles.includes('OFFICE_MANAGER')
      ? '/dashboard'
      : persona.roles.includes('SCHEDULER')
        ? '/visiting-officers'
        : '/counter';

  return (
    <Routes>
      {/* Queue Display (TV mode) — deliberately outside the Shell: a lobby
          kiosk board has no sidebar, no "switch user", just the board. */}
      <Route path="/tv" element={<TvPicker />} />
      <Route path="/tv/:officeCode" element={<TvBoard />} />

      <Route
        element={
          <Shell
            title="ServiceDesk Operations"
            items={[
              { to: '/counter', label: 'Counter Console', icon: '☰' },
              { to: '/dashboard', label: 'Manager Dashboard', icon: '◫' },
              { to: '/visiting-officers', label: 'Visiting Officers', icon: '⛴' },
              { to: '/admin/catalogue', label: 'Offices & Services', icon: '⚙' },
              { to: '/tv', label: 'Queue Display (TV)', icon: '⛶' },
            ]}
          />
        }
      >
        <Route index element={<Navigate to={landing} replace />} />
        <Route path="counter" element={<Console />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="visiting-officers" element={<VisitingOfficers />} />
        <Route path="admin/catalogue" element={<Catalogue />} />
      </Route>

      <Route path="*" element={<Navigate to={landing} replace />} />
    </Routes>
  );
}
